import { Image } from "antd";
import React,{useState} from "react";
import Location from "../../../assets/images/bx-location-plus.svg"
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import { isEmpty, isNil } from "lodash";
import { getYearsFromMonths } from "../../../functions/commons";
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import { useUpdateProfileMutation, useUploadImageMutation } from "../../../store/appSlice";
import { useAppSelector } from "../../../store/store";
import { CircularProgress } from "@mui/material";

function CandidateOverviewAbout({onEdit,data,getUpdatedData}) {
  const[profileImage,setProfileImage]=useState(!isNil(data.profilePicture)&&!isEmpty(data.profilePicture)?data.profilePicture:"")
  const { user} = useAppSelector((state) => state["user"]);

  const [uploadImage] = useUploadImageMutation();
  const [updateProfile] =
    useUpdateProfileMutation()
  
  const[loadingImage,setLoadingImage]=useState(false)



const onImageUpload=(event)=>{
  if(!loadingImage){
  const formData = new FormData()
  formData.append("file", event?.target?.files[0]);
  setLoadingImage(true)
  
  uploadImage(formData)
  .unwrap()
  .then((data) => {
    updateProfileImage(data.url)
  })
  .catch((err) => {
    setLoadingImage(false)

  });
}
}

const updateProfileImage=(imageURL)=>{


  const payload = {
    profilePicture: imageURL,
    param: user?.id,
  };


  updateProfile(payload)
  .unwrap()
  .then((incomingData) => {
    getUpdatedData()
    setLoadingImage(false)
    setProfileImage(imageURL)
    // console.log({ incomingData });
  })
  .catch((err) => {
    setLoadingImage(false)

  });
}




  return (
    <div className='container_sections_wrapper'> 
      <div className="candidate-about__r1-img-about-percentage">

<div className="r1-img-about-percentage__c1-img">

        <input
          id="fileInput" 
          type="file"
          accept="image/*"
          onChange={onImageUpload}
          style={{display:'none'}}
        />
        <label htmlFor="fileInput" className="cursor-pointer">

    {/* //image */}

   {!isEmpty(profileImage) ? <><Image src={profileImage}  preview={false} style={{height:160,width:160,borderRadius:100,opacity:loadingImage?0.2:1}}/>
   
 
   </>
   
   :(
    <div style={{backgroundColor:"#dbdee3",height:160,width:160,borderRadius:100,}}/>
   )} 

 
        </label>
       {loadingImage &&( <div style={{position: 'absolute', top: '30%', left: '22%', transform: 'translate(-50%, -50%)'}} >
   <CircularProgress color="inherit"/>
   </div>
       )
  }
        </div>

        <div className="r1-img-about-percentage__c2-name-title-exp-etc">
          <div className="c2-name-title-exp-etc__name-title">
              <h3>{data.name}</h3>
       
              <h5>{data.title}</h5>
      
          </div>

          <div className="c2-name-title-exp-etc__city-country" style={{margin:0}}>
            {data.industries.map(item=>(
              
            <h4>{item.industryName}</h4>
            ))
}
          </div>
          <div className="c2-name-title-exp-etc__city-country" style={{margin:0}}>
              <h4>
      {getYearsFromMonths(data.yearsOfExp)} of experience
            </h4>
          </div>
  
          <div className="flex_row c2-name-title-exp-etc__exp-rank" >
            {data.jobTypes.map(item=>(
              
            // <h5>{`${item}, `}</h5>

            <div className="coso-skills-cont__ind-skill-div" style={{border:'0.3px solid #d9d9d9'}}>
            <h4>{item}</h4>
          </div>


            ))
}
</div>



          <div className="c2-name-title-exp-etc__city-country">
            <img src={Location} alt="" />
            <h4>{`${data.city}, ${data.country}`}</h4>
          </div>
        
        </div>

      </div>
      <div  onClick={onEdit} className="edit_icon"><ModeEditOutlineOutlinedIcon style={{height:'20px',width:'20px'}}/> </div>
    </div>
  );
}

export default CandidateOverviewAbout;
